export default {"src":"/_next/static/media/bath.6f9f3976.svg","height":24,"width":25};